import { createUseStyles } from 'react-jss'

export default createUseStyles({
  text: {
    '& a': {
      color: 'var(--chat__content__text__color)',
      textDecoration: 'underline'
    }
  },
  messageImage: {
    width: '100%',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '10px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px'
  }
})

